import { BrowserRouter, Routes, Route } from "react-router-dom";

import App from "./App";
import Admin from "./Admin";
import AdminLogin from "./AdminLogin";
import PrivacyPolicy from "./PrivacyPolicy";
import ProductDetails from "./ProductDetails";

function Main() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Home */}
        <Route path="/" element={<App />} />

        {/* Product Pages */}
        <Route
          path="/products/:product"
          element={<ProductDetails />}
        />

        {/* Privacy Policy */}
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />

        {/* Admin */}
        <Route
          path="/admin-login"
          element={<AdminLogin />}
        />

        <Route
          path="/admin"
          element={<Admin />}
        />

      </Routes>
    </BrowserRouter>
  );
}

export default Main;